/**
 * CsvPreviewTable Component
 * 
 * Display preview of CSV data before launching campaign
 */

import React from 'react';
import { Card } from '../ui/card';

const CsvPreviewTable = ({ data }) => {
  // Show first 10 rows
  const previewData = data.slice(0, 10);
  const hasMore = data.length > 10;

  // Normalize column names
  const normalizeKey = (key) => key.toLowerCase().trim();

  return (
    <Card className="bg-gray-800/50 border-gray-700 p-6">
      <div className="mb-4">
        <h3 className="text-lg font-medium text-white">Preview Data</h3>
        <p className="text-sm text-gray-400">
          Showing {previewData.length} of {data.length} appointments
        </p>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-700">
              <th className="text-left text-gray-400 text-xs font-medium py-3 px-2">Phone</th>
              <th className="text-left text-gray-400 text-xs font-medium py-3 px-2">First Name</th>
              <th className="text-left text-gray-400 text-xs font-medium py-3 px-2">Last Name</th>
              <th className="text-left text-gray-400 text-xs font-medium py-3 px-2">DOB</th>
              <th className="text-left text-gray-400 text-xs font-medium py-3 px-2">Appt Date</th>
              <th className="text-left text-gray-400 text-xs font-medium py-3 px-2">Appt Time</th>
              <th className="text-left text-gray-400 text-xs font-medium py-3 px-2">Doctor</th>
            </tr>
          </thead>
          <tbody>
            {previewData.map((row, index) => {
              // Create a map of normalized keys
              const normalizedRow = {};
              Object.keys(row).forEach(key => {
                normalizedRow[normalizeKey(key)] = row[key];
              });

              return (
                <tr 
                  key={index}
                  className="border-b border-gray-700/50 hover:bg-gray-700/30 transition-colors"
                >
                  <td className="text-gray-300 text-sm py-3 px-2">
                    {normalizedRow['phone number'] || '—'}
                  </td>
                  <td className="text-gray-300 text-sm py-3 px-2">
                    {normalizedRow['first name'] || '—'}
                  </td>
                  <td className="text-gray-300 text-sm py-3 px-2">
                    {normalizedRow['last name'] || '—'}
                  </td>
                  <td className="text-gray-300 text-sm py-3 px-2">
                    {normalizedRow['dob'] || '—'}
                  </td>
                  <td className="text-gray-300 text-sm py-3 px-2">
                    {normalizedRow['appointment date'] || '—'}
                  </td>
                  <td className="text-gray-300 text-sm py-3 px-2">
                    {normalizedRow['appointment time'] || '—'}
                  </td>
                  <td className="text-gray-300 text-sm py-3 px-2">
                    {normalizedRow['doctor'] || '—'}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {hasMore && (
        <div className="mt-4 text-center">
          <p className="text-sm text-gray-400">
            ... and {data.length - 10} more appointments
          </p>
        </div>
      )}
    </Card>
  );
};

export default CsvPreviewTable;

